export enum typeCrad{
    residence = 'residence',
    cities = 'cities'
}